<template>
  <div>
    <vx-card card-background="#021a33">
      <vs-row vs-type="flex">
        <vs-col
          vs-w="8"
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="flex-start"
        >
          <div>
            <h5 style="color: white">ROTAS: {{ rotas.length }}</h5>
          </div>
        </vs-col>
        <vs-col
          vs-w="4"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="flex-end"
        >
          <div>
            <ModalCadastroRota :tecnicos="tecnicos" @update="getRotas()" />
          </div>
        </vs-col>
      </vs-row>
    </vx-card>
    <VuePerfectScrollbar
      class="scroll-rota-lista"
      :settings="settings"
      style="background-color: #ebebeb"
    >
      <div id="rotaLista" class="vs-con-loading__container">
        <div v-if="!rotas.length > 0">
          <div class="con-colors mt-10 mb-20">
            <ul>
              <span
                class="px-3 pt-2"
                style="color: grey !important; font-weight: 1000 !important"
              >
                <vs-icon size="large" icon="sentiment_dissatisfied"></vs-icon>
              </span>
            </ul>
          </div>
        </div>
        <vs-list v-for="rota in rotas" :key="rota.id">
          <vx-card
            :class="
              blocked
                ? selectedRot !== rota.id
                  ? 'rota-disabled'
                  : 'active-rota'
                : selectedRot !== rota.id
                ? 'rota'
                : 'active-rota'
            "
            @click="aoClicar(rota)"
          >
            <template slot="no-body">
              <div class="rota-vx-card-body">
                <vs-row
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="flex-start"
                >
                  <vs-col
                    class="pt-3 px-2 pb-3"
                    vs-w="12"
                    vs-type="flex"
                    vs-justify="flex-start"
                    vs-align="flex-start"
                  >
                    <div class="rota-card-inner">
                      <div class="rota-linha-cabecalho">
                        <div class="rota-nome-wrap">
                          <h4 class="rota-nome mb-0">
                            <b>{{ rota.nome }}</b>
                          </h4>
                          <div class="rota-tecnico">
                            <span style="vertical-align: middle;">
                              {{ rota.id_tecnico_responsavel && rota.tecnico && rota.tecnico.nome ? rota.tecnico.nome : 'Sem responsável' }}
                            </span>
                          </div>
                        </div>
                        <span
                          class="os-badge rota-id-pill"
                          title="Identificador interno da rota"
                        >
                          <span class="rota-id-pill__label">ID</span>
                          <span class="rota-id-pill__num">{{ rota.id }}</span>
                        </span>
                        <span
                          v-if="rota.id_tipo_veiculo"
                          class="os-badge rota-badge-tipo"
                          :class="classeBadgeTipoVeiculo(rota.id_tipo_veiculo)"
                          title="Tipo de veículo"
                        >
                          {{ labelTipoVeiculo(rota.id_tipo_veiculo) }}
                        </span>
                        <div class="rota-edit-wrap" @click.stop>
                          <ModalEditarRota
                            @update="getRotas()"
                            :rota="rota"
                            :tecnicos="tecnicos"
                            class="rota-edit-compact"
                          />
                        </div>
                      </div>
                    </div>
                  </vs-col>
                </vs-row>
              </div>
            </template>
          </vx-card>
        </vs-list>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import ModalCadastroRota from "./cadastro";
import ModalEditarRota from "./editar";
import { labelTipoVeiculo } from "@/constants/tiposVeiculo";

/** Lista de rotas para rota.vue e rotasAssoc.vue (levantamento por `lev`). */
export default {
  props: {
    blocked: Boolean,
    lev: { default: 0 },
    tecnicos: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedRot: null,
      settings: { maxScrollbarLength: 60, wheelSpeed: 0.8 },
      rotas: [],
    };
  },
  methods: {
    labelTipoVeiculo,
    classeBadgeTipoVeiculo(id) {
      return Number(id) === 2 ? "badge-warning" : "badge-success";
    },
    aoClicar(rota) {
      if (this.blocked) return;
      this.selectedRot = rota.id;
      this.$emit("update", { id: rota.id, nome: rota.nome });
    },
    async getRotas() {
      await this.$vs.loading({ container: "#rotaLista", scale: 0.6 });
      try {
        const raw = await this.$http.get("rota");
        this.rotas = raw.filter((r) => r.levantamento == this.lev);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close("#rotaLista > .con-vs-loading");
      }
    },
  },
  components: { ...components, ModalCadastroRota, ModalEditarRota },
  mounted() {
    this.getRotas();
  },
};
</script>

<style lang="scss" scoped>
.rota-disabled {
  background-color: #f0f0f0;
  border: 2px solid transparent;
  box-sizing: border-box;
  transition: 0.1s;
  border-radius: 5px;
  font-size: 16px;
  cursor: not-allowed;
  h4 {
    color: #7c7c7c;
  }
  .rota-nome {
    color: #7c7c7c;
  }
  .os-badge.badge-success,
  .os-badge.badge-warning {
    background: #e5e7eb;
    color: #6b7280;
  }
}
.rota {
  background-color: #fff;
  border: 2px solid transparent;
  box-sizing: border-box;
  transition: 0.1s;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  color: #ffca00 !important;
}
.rota:hover {
  background: #eeeeee;
  transform: translateY(-3px);
}
.active-rota {
  background-color: #e8f4f1;
  border: 2px solid #0f766e;
  box-sizing: border-box;
  transition: 0.15s ease-in-out;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
.scroll-rota-lista {
  max-height: 65vh !important;
}
.rota .rota-card-inner,
.rota .rota-nome {
  color: #0f172a !important;
}
.active-rota .rota-card-inner,
.active-rota .rota-nome {
  color: #0f172a !important;
}
.rota-linha-cabecalho {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  width: 100%;
}
.rota-linha-cabecalho .rota-nome-wrap {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.rota-linha-cabecalho .rota-nome {
  word-break: break-word;
  text-align: left;
  font-size: 16px;
  line-height: 1.35;
  font-weight: 600;
}
.rota-linha-cabecalho .rota-nome b {
  font-weight: 700;
}
.rota-linha-cabecalho .rota-tecnico {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
  display: flex;
  align-items: center;
}
.rota-linha-cabecalho .rota-id-pill,
.rota-linha-cabecalho .rota-badge-tipo {
  flex: 0 0 auto;
}
.rota-linha-cabecalho .rota-edit-wrap {
  flex: 0 0 auto;
  margin-left: auto;
  line-height: 1;
}
.rota-id-pill {
  gap: 5px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  background: #f1f5f9;
  color: #475569;
  border: 1px solid rgba(15, 23, 42, 0.08);
}
.rota-id-pill__label {
  opacity: 0.9;
  text-transform: uppercase;
}
.rota-id-pill__num {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, "Cascadia Mono", "Segoe UI Mono", monospace;
}
.active-rota .rota-id-pill {
  background: #dff0ec;
  border-color: rgba(15, 118, 110, 0.25);
  color: #334155;
}
.rota-disabled .rota-id-pill {
  background: #e5e7eb;
  border-color: #d1d5db;
  color: #6b7280;
}
.os-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 999px;
  white-space: nowrap;
  letter-spacing: 0.02em;
}
.badge-success {
  background: #d1fae5;
  color: #065f46;
}
.badge-warning {
  background: #fef3c7;
  color: #92400e;
}
.rota-disabled .os-badge.badge-success,
.rota-disabled .os-badge.badge-warning {
  background: #e5e7eb;
  color: #6b7280;
}
.rota-edit-compact ::v-deep a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  line-height: 1;
}
.rota-edit-compact ::v-deep .feather-icon {
  width: 15px !important;
  height: 15px !important;
  margin-right: 0 !important;
}
.rota .rota-edit-compact ::v-deep .feather-icon,
.active-rota .rota-edit-compact ::v-deep .feather-icon {
  color: #0d9488 !important;
}
.rota-disabled .rota-edit-compact ::v-deep .feather-icon {
  color: #a3a3a3 !important;
}
.rota-vx-card-body {
  width: 100%;
  box-sizing: border-box;
}
.rota-card-inner {
  width: 100%;
  text-align: left;
}
</style>
